/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Measure_Explainer_CapInputs */

const en_measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`capped at ${i?.amount} per request`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "capped at " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " per request" }])
			})
		}
	)
);

const zh_hans1_measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`每次请求封顶 ${i?.amount}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "每次请求封顶 " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }])
			})
		}
	)
);

const pt_br2_measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`com teto de ${i?.amount} por requisição`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "com teto de " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " por requisição" }])
			})
		}
	)
);

const es_measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`con un tope de ${i?.amount} por solicitud`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "con un tope de " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " por solicitud" }])
			})
		}
	)
);

const fr_measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`plafonné à ${i?.amount} par requête`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "plafonné à " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " par requête" }])
			})
		}
	)
);

const de_measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`auf ${i?.amount} pro Anfrage begrenzt`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "auf " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " pro Anfrage begrenzt" }])
			})
		}
	)
);

const ru_measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`не больше ${i?.amount} за запрос`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "не больше " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " за запрос" }])
			})
		}
	)
);

const it_measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`con tetto di ${i?.amount} a richiesta`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "con tetto di " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " a richiesta" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "capped at {amount} per request" |
*
* @param {Measure_Explainer_CapInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_explainer_cap = /** @type {((inputs: Measure_Explainer_CapInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Measure_Explainer_CapInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Measure_Explainer_CapInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { v: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_CapInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_measure_explainer_cap(inputs)
			if (locale === "pt-BR") return pt_br2_measure_explainer_cap(inputs)
			if (locale === "es") return es_measure_explainer_cap(inputs)
			if (locale === "fr") return fr_measure_explainer_cap(inputs)
			if (locale === "de") return de_measure_explainer_cap(inputs)
			if (locale === "ru") return ru_measure_explainer_cap(inputs)
			if (locale === "it") return it_measure_explainer_cap(inputs)
			return en_measure_explainer_cap(inputs)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_CapInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_measure_explainer_cap.parts === "function" ? zh_hans1_measure_explainer_cap.parts(inputs) : [{ type: "text", value: zh_hans1_measure_explainer_cap(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_measure_explainer_cap.parts === "function" ? pt_br2_measure_explainer_cap.parts(inputs) : [{ type: "text", value: pt_br2_measure_explainer_cap(inputs) }]
				if (locale === "es") return typeof es_measure_explainer_cap.parts === "function" ? es_measure_explainer_cap.parts(inputs) : [{ type: "text", value: es_measure_explainer_cap(inputs) }]
				if (locale === "fr") return typeof fr_measure_explainer_cap.parts === "function" ? fr_measure_explainer_cap.parts(inputs) : [{ type: "text", value: fr_measure_explainer_cap(inputs) }]
				if (locale === "de") return typeof de_measure_explainer_cap.parts === "function" ? de_measure_explainer_cap.parts(inputs) : [{ type: "text", value: de_measure_explainer_cap(inputs) }]
				if (locale === "ru") return typeof ru_measure_explainer_cap.parts === "function" ? ru_measure_explainer_cap.parts(inputs) : [{ type: "text", value: ru_measure_explainer_cap(inputs) }]
				if (locale === "it") return typeof it_measure_explainer_cap.parts === "function" ? it_measure_explainer_cap.parts(inputs) : [{ type: "text", value: it_measure_explainer_cap(inputs) }]
				return typeof en_measure_explainer_cap.parts === "function" ? en_measure_explainer_cap.parts(inputs) : [{ type: "text", value: en_measure_explainer_cap(inputs) }]
			})
		}
	)
);